<template>
  <section class="letter full-page-section">
    <div class="content" v-if="!showPop" v-scroll-to="'#letter-pop'">
      <h4 v-html="strings.h2"></h4>
    </div>
    <transition name="fade">
      <div class="pop" :class="{ 'show-all': showFull }" v-if="showPop">
          <div class="content summary">
            <div class="pre">
              <p>Dear Madame/Sir,</p>
              <p>We believe that it’s time for a change. The music industry needs to become more equal and diverse – and it needs to happen now. Even though music consumption has changed completely, and technology has created new opportunities for music creators, the power structures within the industry are not changing fast enough.</p>
              <p>I’m sending you this letter since I believe that you and your company, as leaders for the development of the music industry, has a crucial role to play within this change. When you continue to read, I will give you a contextual background to the daily struggle independent music creators face, and a suggestion of how you could help to make the music industry more democratic, accessible and transparent – for all. </p>
              <p><b>But let’s start with some contextual background.</b></p>
              <p>According to a calculation by <i><a href="https://www.musicbusinessworldwide.com/" target="_blank">Music Business Worldwide</a></i>, the global independent market share of recorded music is 29.88 percent. Of streaming it is only 19.55 percent. The rest is controlled by three major record labels. This means that independent music creators are struggling even more in the era of streaming and playlists. According to a survey we’ve conducted among more than a thousand independent music creators, <a href='' v-scroll-to="'.why-0'">69 percent believe that today’s playlist culture favors mainstream music rather than independent artists.</a></p>
              <p>We believe that equality and diversity within music is not only about gender and ethnicity. It is also about who is behind the music in terms of creation and ownership. The survey referred to above shows that <a href='#scrolldown'>50 percent of independent music creators believe that a major label would restrict them to explore lyrical content and innovative musical styles</a>. Hence, it is critical to even out the unfair structures that characterizes the industry, in order to keep and develop the diversity and power of music.</p>
              <p><b>So, how can you help?</b></p>
              <p>We know that we won’t change the industry overnight, but the first thing we would like you to do is to acknowledge independent music. We want independent music creators to have the ability to tag their music in your product – just as you tag explicit content. This would help independent music creators to stand out in a crowd full of major label backed artists and it would also help consumers to actively choose to listen to independent music. But in order to integrate the most important tag for independent content, we need your help!</p>
              <p>I sincerely hope that you want to be a part of creating a new era for independent music creators and thereby contribute to a more equal and diverse music industry and music climate.</p>
              <p>I’m looking forward to hearing back from you!</p>
              <p>Best Regards, Johan Svanberg,<br> CEO of Record Union</p>
            </div>
          </div>
          <div class="content center">
            <a class="button" @click.prevent="togglePage">Read more</a>
          </div>
      </div>
    </transition>
  </section>
</template>

<script>
import data from '@/data/strings.json'
export default {
  name: 'Letter',
  data () {
    return {
      page: {},
      strings: data.letter,
      showFull: false,
      showPop: false
    }
  },
  methods: {
    togglePage () {
      this.showFull = !this.showFull
    },
    togglePop () {
      this.showPop = !this.showPop
    }
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .letter {
    pointer-events: none;
    h4 {
      pointer-events: auto;
      cursor: pointer;
    }
    &:hover {
      background-size: 62%;
      background-position: 50% 52%;
    }
    .pop {
      pointer-events: auto;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
